import { isObject } from 'lodash';

import { Error } from '@components/WizardContainers/types';

export const isAdServerError = (error: Error) =>
  isObject(error) &&
  'errorType' in error &&
  'errorDetail' in error;
